<template>
  <div
    class="flex flex-col-reverse self-baseline"
    :class="[`${layoutRow ? 'gap-16' : 'gap-24 lg:gap-94 md:flex-row'}`]"
  >
    <div
      class="w-full relative z-10"
      :class="[`${layoutRow ? '' : 'md:w-1/2 md:mt-0'}`]"
    >
      <BoxedText
        box-color-class="bg-surface-secondary"
        element="h2"
        text-class="heading-xxs"
        text-color-class="text-text-on-highlight"
        >{{ title }}
      </BoxedText>
      <div class="py-4"></div>
      <BoxedText
        box-color-class="bg-surface-information"
        text-color-class="text-text-primary-inverted"
        element="p"
        text-class="heading-sm"
      >
        {{ titleExtension }}
      </BoxedText>
      <div class="pt-24">
        <p v-if="text" v-html="markup_markdownLikeTextToHtmlString(text)"></p>
      </div>
      <AppButton
        v-if="linkButtonText"
        class="pt-24"
        :size="linkButtonSize"
        color="secondary"
        :href="linkButtonUrl"
        >{{ linkButtonText }}</AppButton
      >
    </div>
    <div
      v-if="imageUrl"
      class="w-full overflow-hidden relative"
      :class="[`${layoutRow ? '' : 'md:flex-[0_0_auto] md:w-1/2'}`]"
    >
      <div
        class="mx-[-1.6rem] max-h-[32rem] overflow-hidden flex items-center h-full"
        :class="[`${layoutRow ? '' : 'md:mx-0 md:max-h-none'}`]"
      >
        <NuxtImg
          v-if="!imageHasError"
          loading="lazy"
          class="w-full h-auto"
          :class="[`${layoutRow ? '' : 'md:absolute'}`]"
          :src="imgSrc"
          :alt="imageAlt ?? ''"
          :provider="
            imgSrc && imgSrc.includes('cloudfront') ? 'cloudfront' : undefined
          "
          @error="onError"
        />
        <NuxtImg
          v-if="imageHasError"
          loading="lazy"
          class="w-full h-auto"
          :class="[`${layoutRow ? '' : 'md:absolute'}`]"
          src="/images/product_related/product_placeholder.svg"
          alt=""
          provider="cloudfront"
        />
        <AppLabel
          v-if="labelText"
          :color="labelColor"
          :text="labelText"
          class="top-8 right-8 absolute"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';
import type { ButtonSize } from './AppButton.vue';
interface Props {
  title?: string;
  titleExtension?: string;
  text?: string;
  linkButtonText?: string;
  linkButtonUrl?: string;
  linkButtonSize?: ButtonSize;
  imageUrl?: string;
  imageAlt?: string;
  labelColor?: string;
  labelText?: string;
  layoutRow?: boolean;
}

const props = defineProps<Props>();

const imageHasError: Ref<boolean> = ref(false);

const imgSrc = computed(() => {
  let src = props.imageUrl || '';

  if (!src) {
    return undefined;
  }

  if (!src.startsWith('/')) {
    src = `/${src}`;
  }

  if (!src.startsWith('/shop')) {
    src = `/shop${src}`;
  }

  return src;
});

function onError() {
  imageHasError.value = true;
}
</script>
